"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveStyle = void 0;

var _seamlessImmutable = require("seamless-immutable");

var _colors = _interopRequireDefault(require("../../scss/variables/_colors.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var retrieveStyle = function retrieveStyle(theme) {
  return {
    base: {
      color: (0, _seamlessImmutable.getIn)(theme, ['Loading', 'base', 'color'], _colors["default"].loadingBase)
    },
    text: {
      color: (0, _seamlessImmutable.getIn)(theme, ['Loading', 'text', 'color'], _colors["default"].black),
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['Loading', 'text', 'fontSize'], (0, _seamlessImmutable.getIn)(theme, ['Fonts', 'medium']))
    }
  };
};

exports.retrieveStyle = retrieveStyle;